import React, { useState, createContext, useContext } from 'react';
import { translations } from './translations';
export type Language = 'en' | 'pa';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (path: string) => string;
  tArray: <T = any>(path: string) => T[];
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  const getNestedValue = (obj: any, path: string) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };
  const t = (path: string): string => {
    const value = getNestedValue(translations[language], path);
    if (typeof value === 'string') return value;
    // Fallback to English if translation is missing
    const fallback = getNestedValue(translations['en'], path);
    return typeof fallback === 'string' ? fallback : path;
  };
  const tArray = <T = any,>(path: string): T[] => {
    const value = getNestedValue(translations[language], path);
    if (Array.isArray(value)) return value;
    // Fallback to English
    const fallback = getNestedValue(translations['en'], path);
    return Array.isArray(fallback) ? fallback : [];
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    tArray
  }} data-id="element-283" data-mp="4rgu0ewrfufm">
      {/* Add a class to body when Punjabi is selected to help with font rendering if needed */}
      <div className={language === 'pa' ? 'font-pa' : ''} data-id="element-284" data-mp="xgntbg41go1x">{children}</div>
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}